import { render, staticRenderFns } from "./PrizeEditor.vue?vue&type=template&id=c0e2e47e&"
import script from "./PrizeEditor.vue?vue&type=script&lang=js&"
export * from "./PrizeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports